export const MAX_TABLET_RESOLUTION = 1024;
export const MAX_MOBILE_RESOLUTION = 600;
export const LEFT_NAV_WIDTH_DESKTOP = 310;
export const LEFT_NAV_WIDTH_TABLET = 260;
export const MAX_CONTENT_WIDTH_DESKTOP = 1600;
export const MIN_LEFT_NAV_WIDTH_DESKTOP = 150;
export const MAX_LEFT_NAV_WIDTH_DESKTOP = 400;
export const MIN_LEFT_NAV_WIDTH_TABLET = 150;
export const MAX_LEFT_NAV_WIDTH_TABLET = 400;
export const INTRO_WRAPPER_MARGIN_TOP = 150;
export const MAIN_HEIGHT_WITHOUT_DOC_CONTENT = '100vh';
